import React from 'react';

import './skills.css';

//components
import SkillSlider from '../SkillSlider';

//Images
import Py from './../../images/python.png';
import AWS from './../../images/aws.svg';
import Java from './../../images/java.svg';
import Docker from './../../images/docker.svg';
import Jenkins from './../../images/jenkins.svg';
import Claude from './../../images/claude.svg';
import NewRelic from './../../images/newrelic.svg';
import SpringBoot from './../../images/spring-boot.svg';
import Splunk from './../../images/splunk.svg';
import AWSBadge from './../../images/aws-saa-badge.png';

const Skills = () => {


    return(
        <div id="Skills" class="skills-section">
            <section>
                <h1 class="skills-title">Technical Skills</h1>
                <p class="skills-subtitle">Here are some of the main technologies I currently work with</p>

                <div class="skill-list">
                    <SkillSlider img={Py} name="Python" percent="85%" />
                    <SkillSlider img={AWS} name="AWS" percent="80%" />
                    <SkillSlider img={Java} name="Java" percent="80%" />
                    <SkillSlider img={Docker} name="Docker" percent="75%" />
                    <SkillSlider img={Jenkins} name="Jenkins" percent="70%" />
                    <SkillSlider img={Claude} name="Claude Code" percent="75%" />
                    <SkillSlider img={NewRelic} name="New Relic" percent="70%" />
                    <SkillSlider img={SpringBoot} name="Spring Boot" percent="75%" />
                    <SkillSlider img={Splunk} name="Splunk" percent="70%" />
                </div>

                <div className="certifications">
                    <h2 className="certifications-title">Certifications</h2>
                    <a href="https://www.credly.com/badges/4b2ea5f6-12df-46e5-931a-e85ee6d1d215" target="_blank" rel="noreferrer" className="cert-badge">
                        <img src={AWSBadge} alt="AWS Certified Solutions Architect - Associate" />
                        <p>AWS Certified Solutions Architect - Associate</p>
                    </a>
                </div>
            </section>
        </div>
    )
}

export default Skills;